"use client";
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  PDFDownloadLink,
  Font,
} from "@react-pdf/renderer";
import config from "../../../config";
import { Button } from "react-bootstrap";

Font.register({
  family: "Roboto",
  src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxM.woff2",
});

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12 },
  header: {
    fontSize: 16,
    marginBottom: 5,
    textAlign: "center",
    fontWeight: "bold",
  },
  heading: { fontSize: 20, marginBottom: 10 },
  subheading: { fontSize: 14, marginBottom: 10 },
  footer: { textAlign: "center", marginTop: 10 },
  table: { display: "table", width: "100%", border: "1px solid black" },
  row: { flexDirection: "row", borderBottom: "1px solid black" },
  cell: { padding: 5, flex: 1, textAlign: "center", wordWrap: "break-word" },
  headerCell: { fontWeight: "bold", backgroundColor: "#ddd" },
});

const MyDocument = ({ data, fileName }) => {
  if (!data || data.length === 0) return null;

  const columnNames = Object.keys(data[0]).filter((key) => key !== "isDeleted");

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.heading}>Book My Slots</Text>
          <Text style={styles.subheading}>{fileName}</Text>
        </View>

        <View style={styles.table}>
          <View style={[styles.row, styles.headerCell]}>
            {columnNames.map((col) => (
              <Text key={col} style={[styles.cell, styles.headerCell]}>
                {col}
              </Text>
            ))}
          </View>

          {data.map((item, index) => (
            <View
              key={index}
              style={[styles.row, index % 2 === 0 ? { backgroundColor: "#f9f9f9" } : {}]}
            >
              {columnNames.map((col) => (
                <Text key={col} style={styles.cell}>
                  {col === "icon" ? config.Imageurl + item[col] : item[col]?.toString()}
                </Text>
              ))}
            </View>
          ))}
        </View>

        <View style={styles.footer}>
          <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
        </View>
      </Page>
    </Document>
  );
};

const PDFExport = ({ exportData, fileName }) => (
  <div >
    <PDFViewer width="100%" height="700px">
      <MyDocument data={exportData} fileName={fileName} />
    </PDFViewer>

    <Button variant="outline-secondary" style={{ marginTop: 10 }} >
    <PDFDownloadLink document={<MyDocument data={exportData} fileName={fileName} />} fileName={`${fileName}.pdf`} style={styles.footer}>
      {({ loading }) => (loading ? "Loading..." : "Download PDF")}
    </PDFDownloadLink>
    </Button>
  </div>
);

export default PDFExport;
